import Component from './CheckList'

export default Component
